import { SecondaryButton } from "@stenajs-webui/elements";
import { ActionPrompt, Popover } from "@stenajs-webui/tooltip";
import * as React from "react";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useResetForms } from "@/features/route-agreement/hooks/UseResetForms";
import { routeAgreementOriginalSelectors } from "@/features/route-agreement/redux/redux";

interface Props {
  disabled?: boolean;
  onDiscard: () => void;
}

export const CustomerMultilegRouteDiscardChangesButton: React.FC<Props> = ({
  disabled,
  onDiscard,
}) => {
  const originalFormModel = useSelector(
    routeAgreementOriginalSelectors.getEntity
  );
  const { resetForms } = useResetForms(originalFormModel);

  const onDiscardHandler = useCallback(
    async (onRequestClose: () => void) => {
      onRequestClose();
      resetForms();
      onDiscard();
    },
    [resetForms, onDiscard]
  );

  return (
    <Popover
      trigger={"click"}
      placement={"bottom"}
      renderTrigger={(props) => (
        <SecondaryButton label={"Discard"} disabled={disabled} {...props} />
      )}
    >
      {({ onRequestClose }) => (
        <ActionPrompt
          onNo={onRequestClose}
          onYes={() => onDiscardHandler(onRequestClose)}
        />
      )}
    </Popover>
  );
};
